import Vue from 'vue'
import Router from 'vue-router'
import AutoRouter from 'vue-router-auto'
import Cookies from 'js-cookie'
import layoutAdmin from '../layout/layout-admin'
import layoutOpr from '../opr/pages/layout'
import LayoutVms from '../vms/pages/layout'
import LayoutOpenSurvey from '../openSurvey/pages/Main'
import LayoutTopdoor from '../topdoor/layout/layout-admin.vue'
import Login from '../pages/login.vue'
import Desktop from '../pages/desktop.vue'
import PrivacyPolicy from '../pages/privacyPolicy.vue'
import DownLoad from '../pages/download.vue'
import NewSurveyPreview from '@/openSurvey/pages/NewSurveyPreview'

window.CookieManage = Cookies;
Vue.use(Router)

// 自动生成路由
let autoRoutes = AutoRouter({
  rc: require.context('@/pages', true, /\.vue$/),
  redirect: '/login',
  rootFile: 'pages',
})
// let oprAutoRoutes = AutoRouter({
//   rc: require.context('@/opr/pages', true, /\.vue$/),
//   redirect: '/login',
//   rootFile: 'pages',
// })

// 去除独立路由
autoRoutes = autoRoutes.filter(r=>r.path!=='/login')
autoRoutes = autoRoutes.filter(r=>r.path!=='/desktop')
autoRoutes = autoRoutes.filter(r=>r.path!=='/privacyPolicy')
autoRoutes = autoRoutes.filter(r=>r.path!=='/download')

// 结合模板
let routes = [
  {
    path: '/login',
    component: Login
  },
  {
    path: '/desktop',
    component: Desktop
  },
  {
    path: '/privacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/download',
    component: DownLoad
  },
  {
    path: '/previewSurvey',
    name: 'previewSurvey',
    component: NewSurveyPreview
  },
  {
      path: '/h5',
      component: () => import('../opr/pages/views/dataH5.vue'),
      meta: { title: 'dataH5' }
  },
  {
      path: '/h5Two',
      component: () => import('../opr/pages/views/dataH5Two.vue'),
      meta: { title: 'dataH5Two' }
  },
  {
    path: '/dashboard',
    component: () => import('../pages/dashboard.vue'),
    meta: { title: 'dashboard' }
  },
  {
    path: '/',
    component:layoutAdmin,
    children: autoRoutes
  },
  {
    path: '/opr',
    component:layoutOpr,
    children: [
        {
            path: 'homeTotal',
            component: () => import('@/opr/pages/views/HomeTotal.vue'),
            meta: { title: 'homeTotal' }
        },
        {
            path: 'homeRegion',
            component: () => import('@/opr/pages/views/HomeRegion.vue'),
            meta: { title: 'homeRegion' }
        },
        {
            path: 'homeCity',
            component: () => import('@/opr/pages/views/HomeCity.vue'),
            meta: { title: 'homeCity' }
        },
        {
          path: 'homeDoor',
          component: () => import('@/opr/pages/views/HomeDoor.vue'),
          meta: { title: 'homeDoor' }
        },
        {
          path: 'home',
          component: () => import('@/opr/pages/views/HomeDoor.vue'),
          meta: { title: 'homeDoor' }
        },
        {
            path: 'questions',
            component: () => import('@/opr/pages/views/Check/questions.vue'),
            meta: { title: 'questions' }
        },
        {
            path: 'questionsEdit',
            component: () => import('@/opr/pages/views/Check/questionsEdit.vue'),
            meta: { title: 'questions' }
        },
        {
            path: 'questionnaire',
            component: () => import('@/opr/pages/views/Check/questionnaire.vue'),
            meta: { title: 'questionnaire' }
        },
        {
            path: 'questionnaireEdit',
            component: () => import('@/opr/pages/views/Check/questionnaireEdit.vue'),
            meta: { title: 'questionnaire' }
        },
        {
            path: 'report',
            component: () => import('@/opr/pages/views/report.vue'),
            meta: { title: 'report' }
        },
        {
            path: 'systemDoor',
            component: () => import('@/opr/pages/views/systemDoor.vue'),
            meta: { title: 'systemDoor' }
        },
        {
            path: 'systemDoorDetail',
            component: () => import('@/opr/pages/views/systemDoorDetail.vue'),
            meta: { title: 'systemDoor' }
        },
        {
            path: 'userManage',
            component: () => import('@/opr/pages/views/userManage.vue'),
            meta: { title: 'userManage' }
        },
        {
            path: 'userManageEdit',
            component: () => import('@/opr/pages/views/userEdit.vue'),
            meta: { title: 'userManage' }
        },
        {
            path: 'systemManageOne',
            component: () => import('@/opr/pages/views/systemManageOne.vue'),
            meta: { title: 'systemManageOne' }
        },
        {
            path: 'systemManageTwo',
            component: () => import('@/opr/pages/views/systemManageTwo.vue'),
            meta: { title: 'systemManageTwo' }
        },
        {
            path: 'activityManage',
            component: () => import('@/opr/pages/views/activityManage.vue'),
            meta: { title: 'activityManage' }
        },
    ],
  },
  {
    path: '/vms',
    component: LayoutVms,
    children: [
        {
            path: 'home',
            component: () => import('@/vms/pages/views/Home.vue'),
            meta: { title: 'home' }
        },
        {
            path: 'activityManage',
            component: () => import('@/vms/pages/views/activity/activityManage.vue'),
            meta: { title: 'activityManage' }
        },
        {
            path: 'subActivityManage',
            component: () => import('@/vms/pages/views/activity/subActivityManage.vue'),
            meta: { title: 'subActivityManage' }
        },
        {
            path: 'activityEdit',
            component: () => import('@/vms/pages/views/activity/activityEdit.vue'),
            meta: { title: 'activityManage' }
        },
        {
            path: 'activityDetail',
            component: () => import('@/vms/pages/views/activity/activityDetail.vue'),
            meta: { title: 'activityManage' }
        },
        {
            path: 'activityCheck',
            component: () => import('@/vms/pages/views/activity/activityCheck.vue'),
            meta: { title: 'activityManage' }
        },
        {
            path: 'userManage',
            component: () => import('@/vms/pages/views/userManage.vue'),
            meta: { title: 'userManage' }
        },
        {
            path: 'userEdit',
            component: () => import('@/vms/pages/views/userEdit.vue'),
            meta: { title: 'userEdit' }
        },
        {
            path: 'doorManage',
            component: () => import('@/vms/pages/views/systemDoor.vue'),
            meta: { title: 'doorManage' }
        },
        {
            path: 'systemDoorDetail',
            component: () => import('@/vms/pages/views/systemDoorDetail.vue'),
            meta: { title: 'systemDoorDetail' }
        },
        {
            path: 'systemManage',
            component: () => import('@/vms/pages/views/SystemManage.vue'),
            meta: { title: 'systemManage' }
        },
        {
            path: 'reportManage',
            component: () => import('@/vms/pages/views/ReportManage.vue'),
            meta: { title: 'reportManage' }
        },
        {
            path: 'quickReply',
            component: () => import('@/vms/pages/views/quickReply.vue'),
            meta: { title: 'quickReply' }
        },
        {
            path: 'photoSpec',
            component: () => import('@/vms/pages/views/photoSpec.vue'),
            meta: { title: 'photoSpec' }
        },
    ]
  },
  {
    path: '/openSurvey',
    component: LayoutOpenSurvey,
    children: [

        {
          path: 'index',
          component: () => import('@/openSurvey/pages/NewSurvey.vue'),
          meta: { title: 'index' }
        },
        {
          path: 'newSurvey',
          component: () => import('@/openSurvey/pages/NewSurvey.vue'),
          meta: { title: 'newSurvey' }
        },
        {
          path: 'editNewSurvey',
          component: () => import('@/openSurvey/pages/EditNewSurvey.vue'),
          meta: { title: 'editNewSurvey' }
        },
        {
          path: 'userManage',
          component: () => import('@/openSurvey/pages/UserManage.vue'),
          meta: { title: 'userManage' }
        },
        {
          path: 'taskManage',
          component: () => import('@/openSurvey/pages/TaskManage.vue'),
          meta: { title: 'taskManage' }
        },
        {
          path: 'statisticReport',
          component: () => import('@/openSurvey/pages/StatisticReport.vue'),
          meta: { title: 'statisticReport' }
        },
        {
          path: 'statisticList',
          component: () => import('@/openSurvey/pages/StatisticList.vue'),
          meta: { title: 'statisticList' }
        },
        {
          path: 'statisticDetail',
          component: () => import('@/openSurvey/pages/StatisticDetail.vue'),
          meta: { title: 'statisticDetail' }
        },
    ]
  },
  {
    path: '/topdoor',
    component: LayoutTopdoor,
    children: [
        {
          path: 'topdoor/storeManage',
          component: () => import('@/topdoor/pages/topdoor/storeManage.vue'),
          meta: { title: 'topdoor/storeManage' }
        },
        {
          path: 'topdoor/storeEdit',
          component: () => import('@/topdoor/pages/topdoor/storeEdit.vue'),
          meta: { title: 'topdoor/storeEdit' }
        },
        {
          path: 'storeInspection/storeInspectionManage',
          component: () => import('@/topdoor/pages/storeInspection/storeInspectionManage.vue'),
          meta: { title: 'storeInspection/storeInspectionManage' }
        },
        {
          path: 'storeInspection/storeInspectionEdit',
          component: () => import('@/topdoor/pages/storeInspection/storeInspectionEdit.vue'),
          meta: { title: 'storeInspection/storeInspectionEdit' }
        },
        {
          path: 'storeInspection/storeInspectionDetail',
          component: () => import('@/topdoor/pages/storeInspection/storeInspectionDetail.vue'),
          meta: { title: 'storeInspection/storeInspectionDetail' }
        },
    ]
  },
]


let router = new Router({
  // mode: 'history',
  base: '/retailink-management',
  routes,
})


//注册一个全局前置守卫,确保要调用 next 方法，否则钩子就不会被 resolved
router.beforeEach((to, from, next) => {
  // 免登录白名单
  const whiteList = ['/login', '/privacyPolicy', '/download', '/previewSurvey', '/h5', '/h5Two']
  if (!whiteList.includes(to.path) && !CookieManage.get('token')) {
    return next({
      path: '/login'
    })
  }else{
    next()
  }
})
console.log('全部路由', router.options.routes)
export default router



// WEBPACK FOOTER //
// ./src/router/index.js